/****************************************************
 * Module Name:  ProformaHistoryCompareModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, FormControlLabel, Radio, RadioGroup, FormControl, TextField, Typography, Stack, Tooltip, FormGroup, styled, Switch, } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "../../style/modalstyle.css";
import { useEffect } from "react";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import StoneDetailModal from "../common/stoneDetailModal";
// import ExportComponent from "../common/exportComponent"; 
import logo from '../../images/pansuriya.jpg'
import ReportProxy from "../../utility/proxy/manager/reportProxy";
import UtilityProxy from "../../utility/proxy/manager/utilityProxy";
import { LoadingButton } from "@mui/lab";
import CommonSnackbar from "../common/commonSnackBar";

const typeOptions = [
    { value: "local", label: "Local" },
    { value: "export", label: "Export" },
];

const yellowBackGroundColor = "#fff192";

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#2E7D32',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));

// let exportData = {};

// let exportComponentData = (data) => {
//     exportData = data;
// };

const disabledBlackTextFieldStyles = {
    '& .MuiInputBase-input.Mui-disabled': {
        color: 'black',
        WebkitTextFillColor: 'black',
        opacity: 1,
    },
    '& .MuiInputLabel-root.Mui-disabled': {
        color: 'black',
        opacity: 1,
    },
};

const disabledRedTextFieldStyles = {
    '& .MuiInputBase-input.Mui-disabled': {
        color: 'red',
        WebkitTextFillColor: 'red',
        opacity: 1,
    },
    '& .MuiInputLabel-root.Mui-disabled': {
        color: 'black',
        opacity: 1,
    },
};

const ProformaHistoryCompareModal = ({
    show,
    setShow,
    customer,
    user,
    sourceData,
    proformaId,
    handleSave,
    loader
}) => {
    const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
    const defaultBroker = { value: -1, label: " - ", brokerid: -1, username: " - " };
    const [company, setCompany] = useState();

    // const [countryOfOrigin, setCountryOfOrigin] = useState("");
    // const [insurredBy, setInsurredBy] = useState("");
    // const [portOfLoading, setPortOfLoading] = useState("");
    // const [countryOfFinalDestination, setCountryOfFinalDestination] = useState("");
    // const [shippedBy, setShippedBy] = useState("");
    // const [portOfDischarge, setPortOfDischarge] = useState("");
    // const [finalDestination, setFinalDestination] = useState("");
    // const [bankThrough, setBankThrough] = useState(false);

    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [showSnackbar, setShowSnackbar] = useState(false);

    const [hasPreviousData, setHasPreviousData] = useState(false);

    const [stonesLoader, setStonesLoader] = useState(true);
    const [listData, setListData] = useState([]);
    const [currency, setCurrency] = useState("USD");
    const [currency_new, setCurrency_new] = useState("USD");

    const [broker, setBroker] = useState(defaultBroker);
    const [lUser, setLUser] = useState(user);

    const [isBrokerChanged, setIsBrokerChanged] = useState(false);
    const [isUserChanged, setIsUserChanged] = useState(false);
    const [isTradingCompanyChanged, setIsTradingCompanyChanged] = useState(false);
    const [isTypeChanged, setIsTypeChanged] = useState(false);
    const [isInvoiceToCompanyChanged, setIsInvoiceToCompanyChanged] = useState(false);

    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [stoneDetailModalId, setStoneDetailModalId] = useState("");

    const [exchangeRate, setExchangeRate] = useState(1);
    const [exchangeRate_new, setExchangeRate_new] = useState(1);

    const [terms, setTerms] = useState("");
    const [terms_new, setTerms_new] = useState("");

    const [type, setType] = useState("");

    const [remark, setRemark] = useState("");
    const [remark_new, setRemark_new] = useState("");

    const [totalCarat, setTotalCarat] = useState(0);
    const [totalCarat_new, setTotalCarat_new] = useState(0);

    const [shippingCost, setShippingCost] = useState(0);
    const [shippingCost_new, setShippingCost_new] = useState(0);

    const [payableAmount, setPayableAmount] = useState(0);
    const [payableAmount_new, setPayableAmount_new] = useState(0);

    const [formattedDate, setFormattedDate] = useState("");
    const [proformaDate, setProformaDate] = useState("");

    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totalDiscount_new, setTotalDiscount_new] = useState(0);

    const [avgPricePerCarats, setAvgPricePerCarats] = useState(0);
    const [avgPricePerCarats_new, setAvgPricePerCarats_new] = useState(0);

    const [invoiceAmount, setInvoiceAmount] = useState(0);
    const [invoiceAmount_new, setInvoiceAmount_new] = useState(0);

    const [addLessPercent, setAddLessPercent] = useState(0);
    const [addLessPercent_new, setAddLessPercent_new] = useState(0);

    const [addLessAmount, setAddLessAmount] = useState(0);
    const [addLessAmount_new, setAddLessAmount_new] = useState(0);

    const [addToInvoice, setAddToInvoice] = useState(false);
    const [addToInvoice_new, setAddToInvoice_new] = useState(false);

    const [columnNames, setColumnNames] = React.useState([]);
    const [flag, setFlag] = useState(false);

    const [invoiceTo, setInvoiceTo] = useState();

    const [invoiceDays, setInvoiceDays] = useState(0);
    const [invoiceDays_new, setInvoiceDays_new] = useState(0);

    const prepareProformaDetailData = (response) => {


        // setCountryOfOrigin(
        //     response !== null &&
        //         response !== undefined &&
        //         response.countryoforigin !== null
        //         ? response.countryoforigin
        //         : ""
        // );
        // setInsurredBy(
        //     response !== null && response !== undefined && response.ensuredby !== null
        //         ? response.ensuredby
        //         : ""
        // );
        // setPortOfLoading(
        //     response !== null &&
        //         response !== undefined &&
        //         response.portofloading !== null
        //         ? response.portofloading
        //         : ""
        // );
        // setCountryOfFinalDestination(
        //     response !== null &&
        //         response !== undefined &&
        //         response.countryoffinaldestination !== null
        //         ? response.countryoffinaldestination
        //         : ""
        // );
        // setShippedBy(
        //     response !== null && response !== undefined && response.shippedby !== null
        //         ? response.shippedby
        //         : ""
        // );
        // setPortOfDischarge(
        //     response !== null &&
        //         response !== undefined &&
        //         response.portofdischarge !== null
        //         ? response.portofdischarge
        //         : ""
        // );
        // setBankThrough(
        //     response !== null &&
        //         response !== undefined &&
        //         response.bankthrough !== null
        //         ? response.bankthrough
        //         : ""
        // );
        //         setFinalDestination(
        //     response !== null &&
        //         response !== undefined &&
        //         response.finaldestination !== null
        //         ? response.finaldestination
        //         : ""
        // );

        setTerms(
            response !== null && response !== undefined && response.terms !== null
                ? response.terms
                : ""
        );
        setType(
            response !== null && response !== undefined && response.export !== null
                ? response.export
                    ? typeOptions[1]
                    : typeOptions[0]
                : { value: "error", label: "error" }
        );

        setIsTypeChanged(
            response !== null && response !== undefined && response.export !== null &&
            response.export !== sourceData[0].export
        );

        setInvoiceDays(response !== null && response !== undefined && response.days !== null ? response.days : 0);

        setRemark(
            response !== null && response !== undefined && response.remarks !== null
                ? response.remarks
                : null
        );

        setCompany(
            response !== null &&
                response !== undefined &&
                response.tradingcompanyid !== null &&
                response.tradingcompanyname !== null
                ? {
                    value: response.tradingcompanyid,
                    label: response.tradingcompanyname,
                    companylocationid: response.companylocationid,
                    country: response.country
                }
                : undefined
        );
        setIsTradingCompanyChanged(
            response !== null &&
            response !== undefined &&
            response.tradingcompanyid !== null &&
            response.tradingcompanyname !== null &&
            response.tradingcompanyname !== sourceData[0].tradingcompanyname
        );

        setShippingCost(
            response !== null &&
                response !== undefined &&
                response.shippingcost !== null
                ? response.shippingcost
                : ""
        );
        setExchangeRate(
            response !== null &&
                response !== undefined &&
                response.exchangerate !== null
                ? response.exchangerate
                : 1
        );
        setCurrency(
            response !== null &&
                response !== undefined &&
                response.exchangecurrency !== null
                ? response.exchangecurrency
                : "USD"
        );
        setLUser(
            response !== null &&
                response !== undefined &&
                response.userid !== null &&
                response.usercompanyname !== null
                ? response.userid + " | " + response.usercompanyname
                : ""
        );

        setIsUserChanged(response !== null &&
            response !== undefined &&
            response.brokerid !== null && response.userid !== sourceData[0].userid);

        setBroker(
            response !== null &&
                response !== undefined &&
                response.brokerid !== null &&
                response.brokercompanyname !== null
                ? { value: response.brokerid, label: response.brokerid + " | " + response.brokercompanyname, brokerid: response.brokerid, username: response.brokercompanyname }
                : defaultBroker
        );

        setIsBrokerChanged(response !== null &&
            response !== undefined &&
            response.brokerid !== null && response.brokerid !== sourceData[0].brokerid);

        setInvoiceTo(
            response !== null &&
                response !== undefined &&
                response.invoicecustomerid !== null &&
                response.invoicecustomercompanyname !== null
                ? { label: response.invoicecustomercompanyname, value: response.invoicecustomerid, state: response.invoicecountry }
                : undefined
        );

        setIsInvoiceToCompanyChanged(
            response !== null &&
            response !== undefined &&
            response.invoicecustomercompanyname !== null &&
            response.invoicecustomercompanyname !== sourceData[0].invoicecustomercompanyname
        );

        setStonesLoader(false);

    };

    const prepareProformaDetailData_new = (sourceData) => {

        // setCountryOfOrigin_new(sourceData[0].countryoforigin);
        // setInsurredBy_new(sourceData[0].insuredBy);
        // setPortOfLoading_new(sourceData[0].portOfLoading);
        // setCountryOfFinalDestination_new(sourceData[0].countryOfFinalDestination);
        // setShippedBy_new(sourceData[0].shippedBy);
        // setPortOfDischarge_new(sourceData[0].portOfDischarge);
        // setFinalDestination_new(sourceData[0].finalDestination);
        // setBankThrough_new(sourceData[0].bankThrough);
        // setCompany_new(sourceData[0].company); // trading company

        setTerms_new(sourceData[0].terms);
        setInvoiceDays_new(sourceData[0].days);
        setRemark_new(sourceData[0].remark ? sourceData[0].remark : "");
        setShippingCost_new(sourceData[0].shippingcost);
        setExchangeRate_new(sourceData[0].exchangerate);
        setCurrency_new(sourceData[0].exchangecurrency);
    };

    useEffect(() => {
        prepareProformaDetailData_new(sourceData);
        dataProcessing_new(sourceData);
        processDate();
        handleSearch(proformaId);
        setFlag(true)
    }, []);

    useEffect(() => {
        if (flag) {
            prepareColumns();
        }
    }, [flag]);

    const processDate = () => {

        UtilityProxy.getDate((response) => {
            if (response) {
                const parts = sourceData && sourceData[0].canedit ? Utility.GetFormatedDBDate(sourceData[0].date).split("-") : response.errorMessage.split("-");
                setFormattedDate(`${parts[2]}-${parts[1]}-${parts[0]}`);
                if (sourceData) {
                    const proformaParts = Utility.GetFormatedDBDate(sourceData[0].date).split("-");
                    setProformaDate(`${proformaParts[2]}-${proformaParts[1]}-${proformaParts[0]}`);
                }
            }
        });
    }

    const dataProcessing = (response) => {

        let lTotalCarat = 0;
        let lActualPrice = 0;
        let lActualDiscountPrice = 0;
        let newListData = [];
        let lInvoiceAmount = 0;
        let totalValueOfInrMulExchangeRate = 0;
        let totalValueOfInr = 0;
        let onlyUsd = true;
        let addLessAmount = 0;
        let addToInvoice = false;

        response.stones.map((res) => {
            if (res.exchangecurrency === "INR") {
                totalValueOfInrMulExchangeRate += Number(res.size * res.originalprice * Number(res.exchangerate));
                totalValueOfInr += Number(res.size * res.originalprice);
                onlyUsd = false;
            }

            addLessAmount += res.stoneprice * (res.addlesspercent / 100);
            lTotalCarat += Number(res.size);
            lActualPrice += Number(res.size * res.originalprice);
            let actualPrice = Number(res.originalprice * res.size);
            let tempDiscountPrice = res.stoneprice;
            let listOp = {
                ...res,
                olddiscount: res.actualdiscount,
                oldppc: res.discountprice,
                discountprice: tempDiscountPrice,
                olddiscountprice: tempDiscountPrice,
            };
            newListData.push(listOp);

            lInvoiceAmount += Number(actualPrice * ((100 + res.actualdiscount) / 100));
            lActualDiscountPrice += tempDiscountPrice;

            if (!addToInvoice) {
                addToInvoice = res.addToInvoice !== null ? res.addToInvoice : false;
            }

            return true;
        });

        let tempInvoiceAmount = lActualDiscountPrice.toFixed(2);
        let tempPricePerAmount = (lActualDiscountPrice / lTotalCarat).toFixed(2);
        let tempDiscount = ((100 - (lActualDiscountPrice * 100) / lActualPrice) * -1).toFixed(2);

        setTotalDiscount(tempDiscount);
        setTotalCarat(lTotalCarat.toFixed(2));
        setInvoiceAmount(parseFloat(tempInvoiceAmount));
        setAvgPricePerCarats(parseFloat(tempPricePerAmount));
        if (!onlyUsd) {
            setExchangeRate((totalValueOfInrMulExchangeRate / totalValueOfInr).toFixed(2));
        }

        setPayableAmount(((Number(lInvoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * exchangeRate).toFixed(2));
        setAddLessAmount(Number(addLessAmount).toFixed(2));
        setAddLessPercent(Number((addLessAmount / parseFloat(lInvoiceAmount.toFixed(2))) * 100).toFixed(2));
        setAddToInvoice(addToInvoice);

        handleArray(response, sourceData);
    }

    const dataProcessing_new = (sourceData) => {

        let response = sourceData[0];

        let lTotalCarat = 0;
        let lActualPrice = 0;
        let lActualDiscountPrice = 0;
        let newListData = [];
        let lInvoiceAmount = 0;
        let totalValueOfInrMulExchangeRate = 0;
        let totalValueOfInr = 0;
        let onlyUsd = true;
        let addLessAmount = 0;
        let addToInvoice = false;

        response.stones.map((res) => {
            if (res.exchangecurrency === "INR") {
                totalValueOfInrMulExchangeRate += Number(res.size * res.originalprice * Number(res.exchangerate));
                totalValueOfInr += Number(res.size * res.originalprice);
                onlyUsd = false;
            }

            addLessAmount += res.stoneprice * (res.addlesspercent / 100);
            lTotalCarat += Number(res.size);
            lActualPrice += Number(res.size * res.originalprice);
            let actualPrice = Number(res.originalprice * res.size);
            let tempDiscountPrice = res.stoneprice;
            let listOp = {
                ...res,
                olddiscount: res.actualdiscount,
                oldppc: res.discountprice,
                discountprice: tempDiscountPrice,
                olddiscountprice: tempDiscountPrice,
            };
            newListData.push(listOp);

            lInvoiceAmount += Number(actualPrice * ((100 + res.actualdiscount) / 100));
            lActualDiscountPrice += tempDiscountPrice;

            if (!addToInvoice) {
                addToInvoice = res.addtoinvoice !== null ? res.addtoinvoice : false;
            }

            return true;
        });

        let tempInvoiceAmount = lActualDiscountPrice.toFixed(2);
        let tempPricePerAmount = (lActualDiscountPrice / lTotalCarat).toFixed(2);
        let tempDiscount = ((100 - (lActualDiscountPrice * 100) / lActualPrice) * -1).toFixed(2);

        setTotalDiscount_new(tempDiscount);
        setTotalCarat_new(lTotalCarat.toFixed(2));
        setInvoiceAmount_new(parseFloat(tempInvoiceAmount));
        setAvgPricePerCarats_new(parseFloat(tempPricePerAmount));
        if (!onlyUsd) {
            setExchangeRate_new((totalValueOfInrMulExchangeRate / totalValueOfInr).toFixed(2));
        }

        let shipping_cost = response.shippingcost ? response.shippingcost : 0;
        let exchange_Rate = response.exchangerate ? response.exchangerate : 1;

        setPayableAmount_new(((Number(lInvoiceAmount.toFixed(2)) + Number(shipping_cost) + Number(addLessAmount.toFixed(2))) * exchange_Rate).toFixed(2));
        setAddLessAmount_new(Number(addLessAmount).toFixed(2));
        setAddLessPercent_new(Number((addLessAmount / parseFloat(lInvoiceAmount.toFixed(2))) * 100).toFixed(2));
        setAddToInvoice_new(addToInvoice);
    }

    const handleArray = (lListData, sourceData) => {
        let newMainData = [];
        lListData.stones.map((stone) =>
            newMainData.push({
                performaid_stoneid: stone.perfomaid + "_" + stone.stoneid,
                perfomaid: stone.perfomaid,
                stoneid: stone.stoneid,
                stoneprice: stone.stoneprice,
                actualdiscount: stone.actualdiscount,
                discountprice: stone.discountprice,
                originalprice: stone.originalprice,
                proformastatus: stone.status,
                stonestatus: stone.stonedetail.status,
                clarity: stone.stonedetail.clarity,
                certificateid: stone.stonedetail.certificateid,
                color: stone.stonedetail.color,
                colordescriptions: stone.stonedetail.colordescriptions,
                country: stone.stonedetail.country,
                cut: stone.stonedetail.cut,
                cutpolsym: stone.stonedetail.cutpolsym,
                flo: stone.stonedetail.flo,
                lab: stone.stonedetail.lab,
                status: stone.stonedetail.status,
                location: stone.stonedetail.location,
                locationid: stone.stonedetail.locationid,
                pol: stone.stonedetail.pol,
                shape: stone.stonedetail.shape,
                size: stone.stonedetail.size,
                new: lListData.discountprice,
                exchangerate: lListData.exchangerate,
                shippingcost: lListData.shippingcost,
                stonelocation: stone.stonelocation,
                sym: stone.stonedetail.sym,
                stonetransitstatus: stone.stonetransitstatus,
                tradingcompanylocation: lListData.companylocation,
                customercompanyname: lListData.customercompanyname,
                stonetype: stone.stonedetail.stonetype,
                depth: stone.stonedetail.depth,
                depthpercent: stone.stonedetail.depthpercent,
                measurements: stone.stonedetail.measurements,
                tablepercent: stone.stonedetail.tablepercent,
                crownangle: stone.stonedetail.crownangle,
                stonemediaurl: stone.stonedetail.stonemediaurl,
                lrhalf: stone.stonedetail.lrhalf,
                comment: stone.stonedetail.comment,
                fancycolor1: stone.stonedetail.fancycolor1,
                length: stone.stonedetail.length,
                tinge: stone.stonedetail.tinge,
                milky: stone.stonedetail.milky,
                fancycolorintensity: stone.stonedetail.fancycolorintensity,
                fancycolorovertone: stone.stonedetail.fancycolorovertone,
                neworiginalprice: lListData.neworiginalprice,
                defaultdiscount: stone.defaultdiscount,
                addlesspercent: stone.addlesspercent,
            })
        );

        let newDataMap = new Map();
        sourceData[0].stones.forEach(iData => {
            let data = {
                "actualdiscount_new": iData.actualdiscount,
                "addlesspercent_new": iData.addlesspercent,
                "addtoinvoice_new": iData.addtoinvoice,
                "defaultdiscount_new": iData.defaultdiscount,
                "discountprice_new": iData.discountprice,
                "neworiginalprice_new": iData.neworiginalprice,
                "originalprice_new": iData.originalprice,
                "stoneprice_new": iData.stoneprice,
            };

            newDataMap.set(iData.stoneid, data);
        });

        let modifiedNewData = newMainData.map(iData => {

            let stoneDetails = newDataMap.get(iData.stoneid);

            return {
                ...iData,
                ...stoneDetails,
                isdeleted: stoneDetails ? false : true,
            }
        })

        setListData(modifiedNewData);
    };

    const setSnackbarState = (show, message, variant) => {
        setShowSnackbar(show);
        setSnackbarMessage(message);
        setSnackbarVariant(variant);
    };

    const handleSearch = (proformaId) => {
        setStonesLoader(true);
        ReportProxy.GetLatestUpdatedProformaHistoryChecked(proformaId, (response) => {
            if (response) {
                if (response.hasOwnProperty('errorMessage') && response.errorMessage === "No data found") {
                    setSnackbarState(true, response.errorMessage, "warning");
                    setStonesLoader(false);
                } else {
                    setHasPreviousData(true);
                    dataProcessing(response);
                    prepareProformaDetailData(response);
                }
            } else {
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                setStonesLoader(false);
            }
        });
    };

    const handleClose = () => {
        setShow(false);
    };

    const handleStoneDetailModal = (params) => {
        setStoneDetailModalId(params.value);
        setShowStoneDetailModal(true);
    };

    const prepareColumns = () => {
        let columnNames = [];

        Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
            if (columnsData.hasOwnProperty(iColPermission)) {
                const columnData = columnsData[iColPermission];
                columnNames.push(columnData);
                if (columnData.field === "actualdiscount") {
                    columnNames.push(
                        {
                            field: "actualdiscount_new",
                            headerName: "NEW DIS",
                            headerAlign: "center",
                            align: "center",
                            width: 110,
                            editable: false,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(params.row.actualdiscount_new)}</span>
                                </div>
                            ),
                            cellClassName: (params) => params.row.isdeleted ? 'redCell' : params.row.actualdiscount_new !== params.row.actualdiscount ? 'yellowCell' : '',
                        }
                    )
                }
                else if (columnData.field === "discountprice") {
                    columnNames.push(
                        {
                            field: "discountprice_new",
                            headerName: "NEW PPC",
                            headerAlign: "center",
                            align: "center",
                            width: 130,
                            editable: false,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{params.value ? params.value : '0.00'}</span>
                                </div>
                            ),
                            cellClassName: (params) => params.row.isdeleted ? 'redCell' : params.row.discountprice_new !== params.row.discountprice ? 'yellowCell' : '',
                        }
                    )
                }
                else if (columnData.field === "stoneprice") {
                    columnNames.push({
                        field: "stoneprice_new",
                        headerName: "NEW TOTAL",
                        headerAlign: "center",
                        align: "center",
                        width: 120,
                        renderCell: (params) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: '10px' }}>{params.row.stoneprice_new ? Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.stoneprice_new)) : '0.00'}</span>
                            </div>
                        ),
                        editable: false,
                        cellClassName: (params) => params.row.isdeleted ? 'redCell' : params.row.stoneprice_new !== params.row.stoneprice ? 'yellowCell' : '',
                    });

                    columnNames.push({
                        field: "addlesspercent",
                        headerName: "ADD/LESS",
                        headerAlign: "center",
                        align: "center",
                        width: 80,
                        renderCell: (params) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: '10px' }}>{params.value ? params.value : '0.00'}</span>
                            </div>
                        ),
                        editable: false,
                    });
                    columnNames.push({
                        field: "addlesspercent_new",
                        headerName: "NEW ADD/LESS",
                        headerAlign: "center",
                        align: "center",
                        width: 110,
                        renderCell: (params) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: '10px' }}>{params.value ? params.value : '0.00'}</span>
                            </div>
                        ),
                        editable: false,
                        cellClassName: (params) => params.row.isdeleted ? 'redCell' : params.row.addlesspercent_new !== params.row.addlesspercent ? 'yellowCell' : '',
                    });
                }
                else if (columnData.field === "status") {
                    columnNames.push({
                        field: "stonesubstatus",
                        headerName: "STONE SUB STATUS",
                        headerAlign: "center",
                        align: "center",
                        width: 140,
                        renderCell: (params) => params.row.stoneoldstatus !== null ? "IN_TRANSIT" : (params.row.tradingcompanylocation !== params.row.stonelocation ? "YET_TO_ARRIVE" : " - "),
                        valueGetter: (params) => params.row.stoneoldstatus !== null ? "IN_TRANSIT" : (params.row.tradingcompanylocation !== params.row.stonelocation ? "YET_TO_ARRIVE" : " - "),
                    });
                }
            }
        });
        setColumnNames(columnNames);
    }

    const columnsData = {
        "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
            field: "stoneid",
            headerName: "STONEID",
            headerAlign: "center",
            align: "center",
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
                <Button
                    sx={{ textDecorationLine: "underline" }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
            width: 100,
        },
        "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
        "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 75,
            renderCell: renderCellExpand,
        },
        "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            renderCell: renderCellExpand,
        },
        "3597803f-8932-40c6-8de6-81006f4d6d5b": {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 50,
            renderCell: renderCellExpand,
        },
        "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            width: 160,
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        "8296e627-0be5-4a66-830f-ea6867cea137": {
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: renderCellExpand,
        },
        "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            width: 50,
            renderCell: renderCellExpand,
        },
        "19ce7030-402c-495c-84ac-a29093bdb0ac": {
            field: "locationid",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            renderCell: renderCellExpand,
        },
        "ab3e506e-bddb-456d-b967-922dcee74d56": {
            field: "location",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "left",
            width: 130,
            renderCell: renderCellExpand,
        },
        "f97a0118-3891-4f77-abf7-8636c26d594c": {
            field: "country",
            headerName: "COUNTRY",
            headerAlign: "center",
            align: "center",
            width: 118,
            renderCell: renderCellExpand,
        },
        "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            renderCell: renderCellExpand,
        },
        "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
            field: "quality",
            headerName: "QUALITY",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
        },
        "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
            field: "shade",
            headerName: "SHADE",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: renderCellExpand,
        },
        "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
        },
        "5541c182-21b8-496e-b342-b0b89f3d302f": {
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            renderCell: renderCellExpand,
        },
        "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
            field: "size",
            headerName: "CTS",
            headerAlign: "center",
            align: "center",
            width: 55,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
        },
        "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
            field: "originalprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "center",
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.originalprice)
        },
        "798a8663-0f0c-41be-8512-16dd60d5f25e": {
            field: "actualdiscount",
            headerName: "DIS",
            headerAlign: "center",
            align: "center",
            width: 50,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.actualdiscount),
            cellClassName: (params) => 'bold-cell',
        },
        "39c634f1-2644-4307-acbb-983b4de4229e": {
            field: "discountprice",
            headerName: "PPC",
            headerAlign: "center",
            align: "center",
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discountprice),
            cellClassName: (params) => 'bold-cell',
        },
        "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
            field: "stoneprice",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "center",
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.stoneprice)),
            cellClassName: (params) => 'bold-cell',
        },
    }

    const columns = columnNames;

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "2px 4px !important",
                    },
                }}
            >
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />

                {stonesLoader ? (
                    <CircularProgress size="1rem" />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => {
                                handleSearch(proformaId)
                            }}
                            color="primary"
                            fontSize="large"
                            sx={{ cursor: "pointer", height: "1.8rem", width: "1.8rem" }}
                        />
                    </Tooltip>
                )}
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        );
    }

    return (
        <div>
            <Modal backdrop="static" show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>

                {showStoneDetailModal ? (
                    <StoneDetailModal
                        show={showStoneDetailModal}
                        stoneId={stoneDetailModalId}
                        handleClose={() => setShowStoneDetailModal(false)}
                    />
                ) : null}

                <CommonSnackbar
                    show={showSnackbar}
                    message={snackbarMessage}
                    variant={snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={snackbarVariant === "success" ? "Success" :
                        snackbarVariant === "error" ? "Failed" : "Warning"}
                    handleClose={() => setShowSnackbar(false)}
                />

                <Modal.Header closeButton>
                    <Modal.Title>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                                style={{ marginRight: '12px' }}
                            />
                            {"Proforma History"}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {stonesLoader ? <CircularProgress size="1rem" />
                        : hasPreviousData ? (<Box>
                            <Box
                                display="grid"
                                sx={{
                                    gridTemplateColumns: {
                                        md: "1fr 1fr",   // 2 columns on extra-small screens and up
                                        lg: "1fr 1fr 1fr", // 3 columns on medium screens and up
                                    },
                                    width: "100%",
                                    height: "100%",
                                    gap: "15px",
                                }}
                            >
                                <Box display={"flex"} flexDirection={"column"}>
                                    <Box sx={{ display: "flex", width: "100%", mt: 1, gap: "15px" }}>
                                        <Typography sx={{ width: "145px" }}>Customer Company</Typography>
                                        <Typography sx={{ fontWeight: "bold" }}>
                                            {customer.value + " | " + customer.label}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", width: "100%", gap: "15px", mt: 1, }}>
                                        <Typography sx={{ width: "145px" }}>Broker Company</Typography>
                                        <Typography sx={{ fontWeight: "bold", textDecoration: "line-through" }}>
                                            {broker === null ? ("- | -") : (broker.label)}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                                        <Typography sx={{ width: "145px" }}>Broker Company</Typography>
                                        <Typography sx={{ fontWeight: "bold", backgroundColor: isBrokerChanged ? "#fff192" : "", }}>
                                            {sourceData[0].brokercompanyname === null ? ("-") : (sourceData[0].brokerid + " | " + sourceData[0].brokercompanyname)}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", width: "100%", mt: 1, gap: "15px" }}>
                                        <Typography sx={{ width: "145px" }}>User Company</Typography>
                                        <Typography sx={{ fontWeight: "bold", textDecoration: "line-through" }}>{lUser}</Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                                        <Typography sx={{ width: "145px" }}>User Company</Typography>
                                        <Typography sx={{ fontWeight: "bold", backgroundColor: isUserChanged ? "#fff192" : "", }}>
                                            {sourceData[0].userid + " | " + sourceData[0].usercompanyname}</Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "15px",
                                        }}
                                    >
                                        <Box sx={{ alignSelf: "center", mt: 1, width: "175px" }}>
                                            <Typography>Trading Company</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                alignSelf: "center",
                                                width: "100%",
                                                mt: 1,
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", textDecoration: "line-through" }}> {company.label} </Typography>
                                        </Box>
                                    </Box>
                                    {/* UPDATED */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "15px",
                                        }}
                                    >
                                        <Box sx={{ alignSelf: "center", width: "175px" }}>
                                            <Typography>Trading Company</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                alignSelf: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", backgroundColor: isTradingCompanyChanged ? "#fff192" : "" }}>{sourceData[0].tradingcompanyname}</Typography>
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "15px",
                                            mt: "8px",
                                        }}
                                    >
                                        <Box sx={{ alignSelf: "center", width: "175px" }}>
                                            <Typography>Type</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                alignSelf: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", textDecoration: "line-through" }}>{type.label}</Typography>

                                        </Box>
                                    </Box>

                                    {/* UPDATED */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "15px",
                                        }}
                                    >
                                        <Box sx={{ alignSelf: "center", width: "175px" }}>
                                            <Typography>Type</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                alignSelf: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", backgroundColor: isTypeChanged ? "#fff192" : "" }}>{sourceData[0].export ? "Export" : "Local"}</Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box display={"flex"}
                                    flexDirection={"column"}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "15px",
                                            mt: "8px",
                                        }}
                                    >
                                        <Box sx={{ alignSelf: "center", width: "108px" }}>
                                            <Typography>Invoice To</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                maxWidth: "400px",
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", textDecoration: "line-through" }}>{invoiceTo.label}</Typography>
                                        </Box>
                                    </Box>

                                    {/* UPDATED */}

                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "15px",
                                        }}
                                    >
                                        <Box sx={{ alignSelf: "center", width: "108px" }}>
                                            <Typography>Invoice To</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                maxWidth: "400px",
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: "bold", backgroundColor: isInvoiceToCompanyChanged ? "#fff192" : "" }}>{sourceData[0].invoicecustomercompanyname}</Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", gap: "15px", mt: "8px", flexWrap: 'wrap' }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flex: 1,
                                                gap: "15px",
                                                alignItems: "center",
                                                "& .MuiOutlinedInput-input": {
                                                    height: "0.5rem",
                                                },
                                                "& .MuiTextField-root": {
                                                    width: "50%",
                                                    my: 0, // shorthand for marginTop: 0, marginBottom: 0
                                                },
                                            }}
                                        >
                                            <Typography>Proforma Date</Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TextField
                                                    fullWidth
                                                    label="Proforma Date"
                                                    disabled
                                                    value={proformaDate === "" ? formattedDate : proformaDate}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Box>

                                </Box>

                            </Box>
                            {/* {type.value === "export" && Constants.loggedInUser.usertype === 'E' ? (
                            <ExportComponent
                                canEdit={false}
                                countryOfOrigin={countryOfOrigin}
                                insurredBy={insurredBy}
                                portOfLoading={portOfLoading}
                                countryOfFinalDestination={countryOfFinalDestination}
                                shippedBy={shippedBy}
                                portOfDischarge={portOfDischarge}
                                finalDestination={finalDestination}
                                bankThrough={bankThrough}
                                exportComponentData={exportComponentData}
                                notPermitted={false}
                            />
                        ) : null} */}
                            <Box
                                sx={{
                                    width: "100%",
                                    position: "relative",
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        fontSize: Constants.defaultTableFontSize,
                                        fontWeight: Constants.defaultFontWeight,
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "8px",
                                        fontSize: Constants.defaultTableFontSize,
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "15px",
                                        fontSize: Constants.defaultTableFontSize,
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "22px",
                                        fontSize: Constants.defaultTableFontSize,
                                        fontWeight: Constants.defaultFontWeight,
                                    },

                                    "& .MuiTablePagination-selectLabel": {
                                        marginTop: "15px",
                                    },
                                    "& .MuiTablePagination-displayedRows": {
                                        marginTop: "15px",
                                    },
                                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .css-cc8tf1": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .lavenderCell": {
                                        color: "#080808",
                                        backgroundColor: "#D8BFD8",
                                    },
                                    "& .redCell": {
                                        color: "#080808",
                                        backgroundColor: "#f4c1c1 !important",
                                    },
                                    "& .yellowCell": {
                                        color: "#080808",
                                        backgroundColor: yellowBackGroundColor,
                                    },
                                    "& .MuiDataGrid-row.redCell:hover ": {
                                        color: "#080808",
                                        backgroundColor: "#f4c1c1 !important",
                                    },
                                    "& .bold-cell": {
                                        fontWeight: "800",
                                    },
                                    mt: 2
                                }}
                            >
                                <DataGridPro
                                    disableRowSelectionOnClick={true}
                                    autoHeight
                                    slots={{ toolbar: CustomToolbar }}
                                    rows={listData}
                                    columns={columns}
                                    getRowId={(row) => row.stoneid}
                                    loading={stonesLoader}
                                    density="compact"
                                    sx={{ fontSize: Constants.defaultTableFontSize, fontWeight: 'bold' }}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: {
                                                // Hide columns id, the other columns will remain visible
                                                locationid: false,
                                                cutpolsym: false,
                                                createdat: false,
                                                quality: false,
                                                stonesubstatus: false
                                            },
                                        },
                                        sorting: {
                                            sortModel: [{ field: "stoneid", sort: "asc" }],
                                        },
                                        pagination: {
                                            paginationModel: Constants.pageSize,
                                        },
                                    }}
                                    getRowClassName={(params) =>
                                        params.row.isdeleted ? 'redCell' : null
                                    }
                                    pageSizeOptions={Constants.pageSizeOptions}
                                    pagination
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                    apiRef={apiRef}
                                    onCellClick={handleCellClick}
                                    editMode="cell"
                                />
                            </Box>
                            <Box
                                display={"flex"}
                                gridTemplateColumns={"1fr 1fr 1fr 1fr"}
                                width={"100%"}
                                height={"100%"}
                                gap={"15px"}
                                sx={{
                                    "& .MuiOutlinedInput-input": {
                                        padding: "9px 14px !important"
                                    },
                                }}
                            >
                                <Box display={"flex"} flexDirection={"column"} width={"10%"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Pieces"
                                            editable={false}
                                            value={listData.length}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Carats"
                                            editable={false}
                                            value={totalCarat}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Pieces"
                                            editable={false}
                                            value={sourceData[0].stones.length}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: sourceData[0].stones.length !== listData.length ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Carats"
                                            editable={false}
                                            value={totalCarat_new}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: totalCarat_new !== totalCarat ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"17%"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Exchange Rate"
                                            placeholder="Enter Exchange Rate"
                                            value={exchangeRate}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label={
                                                `Shipping Cost ` + (currency === "INR" ? "(USD)" : "")
                                            }
                                            placeholder="Enter Shipping Cost"
                                            value={shippingCost}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Exchange Rate"
                                            placeholder="Enter Exchange Rate"
                                            value={exchangeRate_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: exchangeRate_new !== exchangeRate ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label={
                                                `Shipping Cost ` + (currency === "INR" ? "(USD)" : "")
                                            }
                                            placeholder="Enter Shipping Cost"
                                            value={shippingCost_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: shippingCost_new !== shippingCost ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"17%"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>

                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Discount"
                                            placeholder="Enter Discount"
                                            value={totalDiscount}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />

                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Invoice Amount"
                                            placeholder="Enter invoice amount"
                                            value={invoiceAmount}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>

                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Discount"
                                            placeholder="Enter Discount"
                                            value={totalDiscount_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: totalDiscount_new !== totalDiscount ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }} />

                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Invoice Amount"
                                            placeholder="Enter invoice amount"
                                            value={invoiceAmount_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: invoiceAmount_new !== invoiceAmount ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"19%"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>

                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Price Per Carat Amount"
                                            placeholder="Enter Price Per Carat Amount"
                                            value={avgPricePerCarats}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />

                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Add/Less %"
                                            placeholder="Enter Add/Less Discount"
                                            value={addLessPercent}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>

                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Price Per Carat Amount"
                                            placeholder="Enter Price Per Carat Amount"
                                            value={avgPricePerCarats_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: avgPricePerCarats_new !== avgPricePerCarats ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />

                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Add/Less %"
                                            placeholder="Enter Add/Less Discount"
                                            value={addLessPercent_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: addLessPercent_new !== addLessPercent ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"29%"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <Box sx={{ width: "25%" }}>
                                            <TextField
                                                margin="normal"
                                                type="number"
                                                fullWidth
                                                label="Add/Less Amount"
                                                placeholder="Enter Add/Less Amount"
                                                value={addLessAmount}
                                                editable={false}
                                                disabled={true}
                                                sx={disabledBlackTextFieldStyles}
                                            />
                                        </Box>
                                        <Box sx={{ display: "flex", gap: "10px", width: "75%" }}>
                                            {currency === "INR" && (
                                                <TextField
                                                    label="Payable Amount (USD)"
                                                    id="outlined-start-adornment"
                                                    margin="normal"
                                                    fullWidth
                                                    value={(payableAmount / exchangeRate).toFixed(2)}
                                                    editable={false}
                                                    disabled={true}
                                                    sx={disabledBlackTextFieldStyles}
                                                />
                                            )}
                                            <TextField
                                                label={`Payable Amount ` + (currency === "INR" ? "(INR)" : "(USD)")}
                                                id="outlined-start-adornment"
                                                margin="normal"
                                                fullWidth
                                                value={payableAmount}
                                                editable={false}
                                                disabled={true}
                                                sx={disabledBlackTextFieldStyles}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <Box sx={{ width: "25%" }}>
                                            <TextField
                                                margin="normal"
                                                type="number"
                                                fullWidth
                                                label="Add/Less Amount"
                                                placeholder="Enter Add/Less Amount"
                                                value={addLessAmount_new}
                                                editable={false}
                                                disabled={true}
                                                sx={{
                                                    backgroundColor: addLessAmount_new !== addLessAmount ? '#fff192' : '',
                                                    ...disabledRedTextFieldStyles
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ display: "flex", gap: "10px", width: "75%" }}>
                                            {currency_new === "INR" && (
                                                <TextField
                                                    label="Payable Amount (USD)"
                                                    id="outlined-start-adornment"
                                                    margin="normal"
                                                    fullWidth
                                                    value={(payableAmount_new / exchangeRate_new).toFixed(2)}
                                                    editable={false}
                                                    disabled={true}
                                                    sx={{
                                                        backgroundColor: (payableAmount_new / exchangeRate_new).toFixed(2) !== (payableAmount / exchangeRate).toFixed(2) ? '#fff192' : '',
                                                        ...disabledRedTextFieldStyles
                                                    }}
                                                />
                                            )}
                                            <TextField
                                                label={`Payable Amount ` + (currency_new === "INR" ? "(INR)" : "(USD)")}
                                                id="outlined-start-adornment"
                                                margin="normal"
                                                fullWidth
                                                value={payableAmount_new}
                                                editable={false}
                                                disabled={true}
                                                sx={{
                                                    backgroundColor: payableAmount_new !== payableAmount ? '#fff192' : '',
                                                    ...disabledRedTextFieldStyles
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Box
                                display={"flex"}
                                gridTemplateColumns={"1fr 1fr 1fr 1fr"}
                                width={"100%"}
                                height={"100%"}
                                gap={"15px"}
                                sx={{
                                    "& .MuiOutlinedInput-input": {
                                        padding: "9px 14px !important"
                                    },
                                }}
                            >
                                <Box display={"flex"} flexDirection={"column"} width={"28%"}>
                                    <Box sx={{
                                        display: "flex", gap: "10px", "& .MuiInputLabel-root": {
                                            top: "-7px"
                                        }
                                    }}>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Remark"
                                            // placeholder="Enter Remark"
                                            value={remark}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Terms"
                                            placeholder="Enter Terms"
                                            value={terms}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                    </Box>
                                    <Box sx={{
                                        display: "flex",
                                        gap: "10px",
                                        "& .MuiInputLabel-root": {
                                            top: "-7px"
                                        }
                                    }}>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Remark"
                                            placeholder="Enter Remark"
                                            value={remark_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: remark_new !== remark ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="Terms"
                                            placeholder="Enter Terms"
                                            value={terms_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: terms_new !== terms ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"7%"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Days"
                                            placeholder="Enter Days"
                                            value={invoiceDays}
                                            editable={false}
                                            disabled={true}
                                            sx={disabledBlackTextFieldStyles}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <TextField
                                            margin="normal"
                                            type="number"
                                            fullWidth
                                            label="Days"
                                            placeholder="Enter Days"
                                            value={invoiceDays_new}
                                            editable={false}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: invoiceDays_new !== invoiceDays ? '#fff192' : '',
                                                ...disabledRedTextFieldStyles
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"35%"} marginTop={"1rem"} gap={"20px"}>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center", width: "21rem" }}>
                                            <Typography sx={{ marginBottom: "0px", alignItems: "center", mr: "2rem" }}>Exchange Currency</Typography>
                                            <RadioGroup
                                                row
                                                name="Exchange Currency"
                                                value={currency}
                                                editable={false}
                                            >
                                                <FormControlLabel
                                                    sx={{ marginBottom: "0px" }}
                                                    value="USD"
                                                    control={<Radio />}
                                                    label="USD"
                                                />
                                                <FormControlLabel
                                                    sx={{ marginBottom: "0px" }}
                                                    value="INR"
                                                    control={<Radio />}
                                                    label="INR"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                        <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: 'wrap' }}>
                                            <Typography
                                                sx={{ marginRight: "10px", alignItems: "center", }}
                                            >
                                                Add to Invoice: </Typography>
                                            <FormGroup>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Typography>NO</Typography>
                                                    <AntSwitch
                                                        onClick={(e) => e.preventDefault()}
                                                        checked={addToInvoice}
                                                        inputProps={{ 'aria-label': 'ant design' }} />
                                                    <Typography>YES</Typography>
                                                </Stack>
                                            </FormGroup>
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: "10px", }}>
                                        <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center", width: "21rem" }}>
                                            <Typography sx={{ marginBottom: "0px", alignItems: "center", mr: "2rem" }}>
                                                Exchange Currency</Typography>
                                            <RadioGroup
                                                row
                                                name="Exchange Currency"
                                                value={currency_new}
                                                editable={false}
                                            >
                                                <FormControlLabel
                                                    sx={{ marginBottom: "0px" }}
                                                    value="USD"
                                                    control={<Radio />}
                                                    label="USD"
                                                />
                                                <FormControlLabel
                                                    sx={{ marginBottom: "0px" }}
                                                    value="INR"
                                                    control={<Radio />}
                                                    label="INR"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                        <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: 'wrap' }}>
                                            <Typography
                                                sx={{ marginRight: "10px", alignItems: "center", }}
                                            >
                                                Add to Invoice: </Typography>
                                            <FormGroup>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Typography>NO</Typography>
                                                    <AntSwitch
                                                        onClick={(e) => e.preventDefault()}
                                                        checked={addToInvoice_new}
                                                        inputProps={{ 'aria-label': 'ant design' }} />
                                                    <Typography>YES</Typography>
                                                </Stack>
                                            </FormGroup>
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Box>

                        </Box>) : (<Box />)}
                </Modal.Body>
                <Modal.Footer>
                    <Box sx={{
                        "& .MuiLoadingButton-root": {
                            padding: "7px 10px"
                        }
                    }}>
                        {hasPreviousData ? (<LoadingButton
                            variant="contained"
                            size="small"
                            type="Submit"
                            component="label"
                            sx={{ mr: "5px" }}
                            onClick={() => handleSave(proformaId)}
                            color="success"
                            loading={loader}
                            loadingPosition="start"
                        >
                            MARK AS CHECKED
                        </LoadingButton>) : <Box />}
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleClose}
                            sx={{ mr: 5 }}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Modal.Footer>
            </Modal>
        </div >
    );
};

export default ProformaHistoryCompareModal;
